import { useState, useEffect } from 'react';
import '../style/CookieConsent.css';

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const choice = localStorage.getItem('cookieConsent');
        if (!choice) {
            // Small delay so it doesn't flash immediately on load
            const timer = setTimeout(() => setVisible(true), 1200);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-banner-inner">
                <div className="cookie-icon">🍪</div>
                <div className="cookie-text">
                    <p className="cookie-title">We use cookies</p>
                    <p className="cookie-desc">
                        We use cookies to improve your experience on our website, analyse traffic,
                        and personalise content. By clicking <strong>"Accept All"</strong>, you
                        consent to our use of cookies.{' '}
                        <a href="/contact" className="cookie-link">Learn more</a>
                    </p>
                </div>
                <div className="cookie-actions">
                    <button className="cookie-btn-decline" onClick={handleDecline}>
                        Decline
                    </button>
                    <button className="cookie-btn-accept" onClick={handleAccept}>
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    );
}
